// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2OTlO","vLegacy":"SelectSecondary_vLegacy__1fJM4","error":"SelectSecondary_error__YgiMM","disabled":"SelectSecondary_disabled__1y7eP"};